import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import AssignAgentModal from 'modules/journey/AssignAgentModal';
import JourneysSummaryModal from 'modules/journey/JourneysSummaryModal';
import JobDetail from 'modules/journey/detail';

import { getJourneysSummaryModalProps } from 'redux/modules/journeys/selectors';

import Unassigned from './Unassigned';
import Assigned from './Assigned';
import Finished from './Finished';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

const RedirectToDispatching = () => {
  const unassignedSection = useSelector((state) =>
    getSpecificClientConfig(state, constants.UNASSIGNED_SECTION)
  );

  if (!unassignedSection) {
    return <Redirect to={`/fleet/dispatching`} />;
  }

  return null;
};

const Jobs = ({ match }) => {
  const { open: showJobsSummaryModal } = useSelector(getJourneysSummaryModalProps);

  const unassignedSection = useSelector((state) =>
    getSpecificClientConfig(state, constants.UNASSIGNED_SECTION)
  );

  return (
    <Fragment>
      <Route
        path={match.url}
        exact
        render={() =>
          !unassignedSection ? (
            <Redirect to={`${match.url}/assigned`} />
          ) : (
            <Redirect to={`${match.url}/unassigned`} />
          )
        }
      />
      <Route path={`${match.url}/unassigned`} component={RedirectToDispatching} />
      <Switch>
        <Route path={`${match.url}/unassigned`} component={Unassigned} />
        <Route path={`${match.url}/assigned`} component={Assigned} />
        <Route path={`${match.url}/finished`} component={Finished} />
        <Route path={`${match.url}/:id`} component={JobDetail} />
      </Switch>
      <AssignAgentModal />
      {showJobsSummaryModal && <JourneysSummaryModal />}
    </Fragment>
  );
};

Jobs.propTypes = {
  match: PropTypes.object,
  error: PropTypes.object,
};

export default Jobs;
